// http://vuex.vuejs.org/en/getters.html
import { isEmpty, includes } from 'lodash'
import { MODULE_CONTRACTS, MODULE_CATERING } from '../../../config'

// if has token, we assumed that user is logged in our system
export const isLogged = ({ token }) => !isEmpty(token)
// get current user data
export const currentUser = ({ user }) => user

export const hasModuleContracts = ({ user }) => {
  if (!isEmpty(user)) {
    //includes(user.modules.split(','), MODULE_CONTRACTS) || false
    return parseInt(user.mod_contracts, 10) || false
  }
};

export const hasModuleCatering = ({ user }) => {
  if (!isEmpty(user)) {
    //return includes(user.modules.split(','), MODULE_CATERING) || false;
    return parseInt(user.mod_catering, 10) || false
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/vuex/getters.js